import React, { useEffect, useRef, LegacyRef } from 'react';
import classnames from 'classnames';
import { useIntersectionObserver } from '@fiverr-private/hooks';
import { useBreakpoints } from '@fiverr-private/business_blocks';
import { NotableClientsBar, NotableClientsAbout } from '@fiverr-private/seller_presence';
import { SafeWrapper } from '@fiverr-private/seller_pages_toolbox';
import { useMonitoring } from '../../../monitoring/index';
import { useFreelancerPageContext } from '../../FreelancerPageContext';
import { NotableClientsProps } from './types';

import './notable-clients.scss';

const NotableClients: React.FC<NotableClientsProps> = ({ className, user, source, wrapTitle, verticalOnSm }) => {
    const { notableClients } = useFreelancerPageContext();
    const { isMD } = useBreakpoints();
    const { fireEvents, Providers } = useMonitoring();

    useEffect(() => {
        fireEvents({
            [Providers.BigQuery]: {
                type: 'notable_clients_component_is_shown_business_seller_page',
                event_source: source,
            },
        });
    }, [source]);

    const onHoverBI = () => {
        fireEvents({
            [Providers.Mixpanel]: {
                type: 'hover on notable clients',
                source,
            },
        });
    };

    const observableRef = useRef<HTMLElement>(null);
    const entry = useIntersectionObserver(observableRef, { threshold: 1 });
    const isVisible = Boolean(entry?.isIntersecting);

    useEffect(() => {
        if (isVisible) {
            fireEvents({
                [Providers.Mixpanel]: {
                    type: 'seller page - notable clients viewed',
                },
            });
        }
    }, [isVisible, Providers.Mixpanel, fireEvents]);

    const Component = verticalOnSm && !isMD ? NotableClientsAbout : NotableClientsBar;

    const titleProps = {
        newBadge: false,
        infoIcon: false,
        educate: false,
    };

    return (
        <div
            ref={observableRef as LegacyRef<HTMLDivElement>}
            className={classnames(className, 'seller-notable-clients', { 'wrap-title': wrapTitle })}
            onMouseEnter={onHoverBI}
        >
            <Component
                notableClients={notableClients}
                titleProps={titleProps}
                seller={{ name: user.name, profilePhoto: user.profileImageUrl }}
                hideClientPopover={!isMD}
                isSlimDesign={wrapTitle}
                wrap={wrapTitle}
            />
        </div>
    );
};

const SafeNotableClients = SafeWrapper(NotableClients, 'NotableClients');

export { SafeNotableClients as NotableClients };
